import { styled } from '../../../theme/stitches.config';
import * as Stitches from '@stitches/react';
import { getSocialIconAsBgImage } from '@sportal365/smp-widget-utils/src/icons';
import { Themes } from '../../../types';

export const SocialsIconContainer = styled.withConfig({ componentId: 'SocialsIcon', displayName: 'SocialsIconContainer' })('div', {
  backgroundSize: 'contain',
  backgroundRepeat: 'no-repeat',
  backgroundPosition: 'center',
  minWidth: '100%',
  display: 'flex',
  overflow: 'hidden',
  variants: {
    size: {
      mobile: {
        width: '26px',
        height: '26px',
      },
      desktop: {
        width: '32px',
        height: '32px',
      },
    },
  },
});

type ISMPSocialsIconProps = {
  key: number;
  href: string;
  social: string;
  dataTheme?: Themes | null;
  isMobile?: boolean;
};

export const SMPSocialsIcon = ({ key, href, social, dataTheme, isMobile }: ISMPSocialsIconProps) => {
  const variant = dataTheme === 'client' ? 'light' : dataTheme;
  const icon = getSocialIconAsBgImage(social, variant ?? 'light');

  return (
    <a key={key} href={href} target='_blank' rel='noreferrer'>
      <SocialsIconContainer id={`social`} size={isMobile ? 'mobile' : 'desktop'} style={{ backgroundImage: `url("${icon}")` }} />
    </a>
  );
};

export type StyledSMPSocialsIconVariants = Stitches.VariantProps<typeof SocialsIconContainer>;
